export default [
  {
    path: '',
    name: 'member_card_orders',
    component: () => import('./List'),
  },
]
